import { render, staticRenderFns } from "./BatchStatusBadge.vue?vue&type=template&id=7462a027"
import script from "./BatchStatusBadge.vue?vue&type=script&lang=js"
export * from "./BatchStatusBadge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports